module.exports = __webpack_public_path__ + "static/media/logo.e62c7ed3.png";